export const buildNumber = '20250116.9';
export const version = '3.7.3';
export const latestCommit = 'fafa75490d904332a52f078285b4735dc5a6317b';
